import styled from 'styled-components';

export const Container = styled.div`
  height: 52px;
  background: ${({ theme }) => theme.colors?.gray07};

  width: 100vw;
  position: fixed;
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
`;
